import { schoolTokenAxios } from "../axios";

const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;

let admissionEnquiry_url = `${SCHOOL_BASE}/admissionEnquiry`;

export const addStatus = (body) =>
  schoolTokenAxios.post(`${admissionEnquiry_url}/addStatus`, body);

export const editStatus = (body) =>
  schoolTokenAxios.put(`${admissionEnquiry_url}/editStatus`, body);

export const deleteStatus = (statusDocId) =>
  schoolTokenAxios.delete(
    `${admissionEnquiry_url}/deleteStatus/${statusDocId}`
  );
// source
export const getSourceList = (payload) =>
  schoolTokenAxios.get(`${admissionEnquiry_url}/getSourceList`, { payload });

export const addSource = (body) =>
  schoolTokenAxios.post(`${admissionEnquiry_url}/addSource`, body);

export const editSource = (body) =>
  schoolTokenAxios.put(`${admissionEnquiry_url}/editSource`, body);

export const deleteSource = (sourceId) =>
  schoolTokenAxios.delete(`${admissionEnquiry_url}/deleteSource/${sourceId}`);

export const getAdmissionEnquiry = (params) => {
  return schoolTokenAxios.get(`${admissionEnquiry_url}/getAdmissionEnquiry`, {
    params: params,
  });
};
export const getAdmissionEnquiryTable = (params) => {
  return schoolTokenAxios.get(
    `${admissionEnquiry_url}/getAdmissionEnquiryTable`,
    {
      params: params,
    }
  );
};
export const getAdmissionEnquiryCount = (params) => {
  return schoolTokenAxios.get(
    `${admissionEnquiry_url}/getAdmissionEnquiryCount`,
    {
      params: params,
    }
  );
};

export const updateAdmissionEnquiry = (payload) => {
  return schoolTokenAxios.put(
    `${admissionEnquiry_url}/updateAdmissionEnquiry`,
    payload
  );
};
export const changeStatusOfAdmissionEnquiry = (payload) => {
  return schoolTokenAxios.put(
    `${admissionEnquiry_url}/changeStatusOfAdmissionEnquiry`,
    payload
  );
};

export const deleteAdmissionEnquiry = (payload) => {
  return schoolTokenAxios.delete(
    `${admissionEnquiry_url}/deleteAdmissionEnquiry/${payload}`
  );
};

export const registerFreshStudentByAdmissionEnquiry = (payload) => {
  return schoolTokenAxios.post(
    `${admissionEnquiry_url}/registerFreshStudentByAdmissionEnquiry`,
    payload
  );
};

export const addFormFeeStructure = (payload) => {
  return schoolTokenAxios.post(
    `${admissionEnquiry_url}/addFormFeeStructure`,
    payload
  );
};

export const updateFormFeeStructure = (payload) => {
  return schoolTokenAxios.put(
    `${admissionEnquiry_url}/updateFormFeeStructure`,
    payload
  );
};

export const deletePreviousSchool = (payload) => {
  return schoolTokenAxios.delete(
    `${admissionEnquiry_url}/deletePreviousSchool/${payload}`
  );
};

export const assignSingleAdmissionEnquiry = (payload) => {
  return schoolTokenAxios.put(
    `${admissionEnquiry_url}/assignSingleAdmissionEnquiry`,
    payload
  );
};

/***********************Counselor Api**************************/

export const linkExistingStaffAsCounselor = (payload) => {
  return schoolTokenAxios.put(
    `${admissionEnquiry_url}/linkExistingStaffAsCounselor`,
    payload
  );
};

export const addFreshCounselor = (payload) => {
  return schoolTokenAxios.post(
    `${admissionEnquiry_url}/addFreshCounselor`,
    payload
  );
};

export const updateCounselorArea = (payload) => {
  return schoolTokenAxios.put(
    `${admissionEnquiry_url}/updateCounselorArea`,
    payload
  );
};

export const getAssignedFormDetailOfCounselor = (params) => {
  return schoolTokenAxios.get(
    `${admissionEnquiry_url}/getAssignedFormDetailOfCounselor`,
    {
      params: params,
    }
  );
};

/***********************Visuals Api**************************/

export const getFormCount = (params) => {
  return schoolTokenAxios.get(`${admissionEnquiry_url}/getFormCount`, {
    params: params,
  });
};

export const getFormCountByGender = (params) => {
  return schoolTokenAxios.get(`${admissionEnquiry_url}/getFormCountByGender`, {
    params: params,
  });
};

export const getFormCountWithClass = (params) => {
  return schoolTokenAxios.get(`${admissionEnquiry_url}/getFormCountWithClass`, {
    params: params,
  });
};

export const bulkUploadAdmissionEnquiry = (payload) => {
  return schoolTokenAxios.post(
    `${admissionEnquiry_url}/bulkUploadAdmissionEnquiry`,
    payload
  );
};
